
import { IField, IPageable, Params, IAction } from '../types/table/interfaces.type'
import { UseQueryResult } from '@tanstack/react-query'
import CustomTable from './common/table/CustomTable'
import { Box } from '@mui/system'

export interface HistoryProps<T> {
  filters: Params<T>
  fields: IField<T>[]
  fetchFunc: (
    | ((params: Params<T>) => UseQueryResult<IPageable<T>, Error>)
    | ((id: string) => UseQueryResult<IPageable<T>, Error>)
    | ((params: Params<T>) => Promise<IPageable<T>>)
    | ((id: string) => Promise<T>)
  )
  id?: string
  actions?: IAction<T>[]
  shadeRow?: (row: T) => boolean
  shadeBg?: string
  shadeColor?: string
  checkboxSelect?: boolean
  onRowSelect?: (row: T, checked: boolean) => void
  isRowSelected?: (row: T) => boolean
  sortableFields?: (keyof T)[]


}

const History = <T extends {}>({
  filters,
  fields,
  fetchFunc,
  actions,
  shadeRow,
  shadeBg,
  shadeColor,
  checkboxSelect,
  onRowSelect,
  isRowSelected,
  sortableFields,

}: HistoryProps<T>) => {
  


  return (
    <Box sx={{ width: '100%' }}>
      <CustomTable<T> fullBleedMobile={false}
        filters={filters}
        fields={fields}
        fetchFunc={fetchFunc}
        actions={actions}
        shadeRow={shadeRow}
        shadeBg={shadeBg}
        shadeColor={shadeColor}
        checkboxSelect={checkboxSelect}
        onRowSelect={onRowSelect}
        isRowSelected={isRowSelected}
        sortableFields={sortableFields}
        highlightDiff={true}
      />
    </Box>
  )
}

export default History